import React from "react";

const Spinner = ({ customStyle }) => {
  return (
    <div className={` ${customStyle} border-0`}>
      <div role='status' className={`animate-spin ${customStyle} border-black border-r-white rounded-full`}>
        <span className='sr-only'>Loading..</span>
      </div>
    </div>
  );
};

export default Spinner;
